var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.375V13.9583C15 13.2069 14.6839 12.4862 14.1213 11.9549C13.5587 11.4235 12.7956 11.125 12 11.125H6C5.20435 11.125 4.44129 11.4235 3.87868 11.9549C3.31607 12.4862 3 13.2069 3 13.9583V15.375M12 5.45833C12 7.02314 10.6569 8.29167 9 8.29167C7.34315 8.29167 6 7.02314 6 5.45833C6 3.89353 7.34315 2.625 9 2.625C10.6569 2.625 12 3.89353 12 5.45833Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.2c13ed1335f948babde3760a46c47596.svg";
export { ForwardRef as ReactComponent };